export const DAYS_ALLOWED_FOR_CANCEL = 30;
